module.exports = __webpack_public_path__ + "img/path.15dc7445.jpg";